import React from 'react';
import _ from 'lodash';
import {FormControls} from '../../../../shared/library';
import {bindMethods} from '../../../../shared/utilities/componentHelpers';
import {TrashcanIcon, VideoUploadIcon} from '../../../../shared/Svgs';
import {MEDIA_TYPES} from '../../../../shared/utilities/constants';
import styles from './css/CaptionContainerItem.styl';

const {Button, TextArea} = FormControls;

export default class CaptionContainerItem extends React.Component {
  static propTypes = {
    changeHandler: React.PropTypes.func,
    height: React.PropTypes.number,
    media: React.PropTypes.object,
    mobile: React.PropTypes.bool,
  };

  /**
   * CaptionContainerItem Component constructor
   * @param  {Object}  props - props object
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.state = {
      userCaption: _.get(props, 'media.caption') || '',
    };

    bindMethods(this, [
      'handleInputChange',
      'handleMarkForDeletion',
      'handleInputInit',
    ]);
  }

  /**
   * Updates field size on initialization
   * @param  {documentElement} target   textarea element
   * @return {Undefined} Returns nothing
   */
  handleInputInit(target) {
    if (target.value) {
      this.updateFieldSize(target);
    }
  }

  /**
   * Handle an input change
   * @param  {Object} e The Event object
   * @param  {String} key The state key
   * @return {Undefined} Returns nothing
   */
  handleInputChange(e, key) {
    e.persist();
    const target = e.target;

    this.updateFieldSize(target, key);
  }

  /**
   * Updates field size
   * @param  {documentElement} target   textarea element
   * @param  {String} key               State key
   * @return {Undefined} Returns nothing
   */
  updateFieldSize(target, key) {
    const value = target.value;
    const stateObj = {};

    stateObj[key] = value;
    this.setState(stateObj);
    this.props.changeHandler({
      id: this.props.media.id,
      caption: value,
    });

    // the following is necessary, not a mistake. sets to auto so that it can properly read scrollHeight
    target.style.height = 'auto';
    target.style.height = `${target.scrollHeight}px`;
  }

  /**
   * Marks item for deletion
   * @return {Undefined} Returns nothing
   */
  handleMarkForDeletion() {
    this.props.changeHandler({
      id: this.props.media.id,
      remove: true,
    });
    this.setState({deleteItem: !this.state.deleteItem});
  }

  /**
   * React Component render.
   * @return {JSX} CaptionContainerItem rendered.
   */
  render() {
    const {height, media, mobile} = this.props;
    const heightStyle = mobile ? {height: `${height}px`} : {};
    const caption = this.state.userCaption;
    const placeholderText = caption ? null : 'Add caption';

    return _.isObject(media) &&
      _.has(media, 'url') &&
      !this.state.deleteItem ? (
      <div
        className={`${styles.CaptionContainerItem}${
          mobile ? ` ${styles.mobile}` : ''
        }`}
      >
        <div className={styles.imgContainer} style={heightStyle}>
          {mobile ? null : (
            <div className={styles.overlayDelete}>
              <Button
                btnType="primary"
                className={styles.delete}
                handleClick={this.handleMarkForDeletion}
              >
                Delete
              </Button>
            </div>
          )}
          {media.mediaType === MEDIA_TYPES.video ? (
            <div className={styles.mediaDisplay}>
              <VideoUploadIcon />
              <p>{media.filename}</p>
            </div>
          ) : (
            <img src={media.url} />
          )}
        </div>
        <div className={styles.captionContainer}>
          <TextArea
            className={styles.textArea}
            handleChange={_.partial(this.handleInputChange, _, 'userCaption')}
            id={'caption'}
            name="userCaption"
            onInit={this.handleInputInit}
            placeholder={placeholderText}
            value={this.state.userCaption}
          />
          {mobile ? (
            <div className={styles.mobileDeleteContainer}>
              <Button
                btnType="primary"
                className={styles.mobileDelete}
                handleClick={this.handleMarkForDeletion}
              >
                <div>
                  <span>
                    <TrashcanIcon />
                  </span>
                  Delete
                </div>
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/CaptionContainerItem.js